
	export default {
		data() {
			return {}
		},
		mounted() {
		},
		head() {
			return {
				title: 'Privacy Policy | American Credit',
				meta : [
					{
						hid: 'description',
						name: 'description',
						content: 'Your privacy and security are very important to us at American Credit. Please review our Privacy Policy to understand how we use and protect your data.'
					},
					{
						hid: 'keywords',
						name: 'keywords',
						content: 'American Credit, Privacy'
					}
				]
			}
		}
	}
